<template>
  <div>
    <div id="weixin"></div>
  </div>
</template>
<script>
import echarts from "echarts"
export default {
  props:['weixinList'],
  data(){
    return {
      option2: {
        backgroundColor: "#fff",
        yAxis: [
          {
            type: "category",
            axisLine: {
              show: false, //坐标线
            },
            axisTick: {
              show: false, //小横线
            },
            axisLabel: {
              show: true,
              textStyle: {
                //坐标轴字颜色
                color: function (params, index) {
                  let colorLists = [
                    "#3054EC",
                    "#1A8FFF",
                    "#13C2C2",
                    "#52C41B",
                    "#A0D912",
                    "#FAD60F",
                    "#F9AD13",
                    "#FA8C15",
                    "#F95B1C",
                    "#FE4D4F",
                  ];
                  return colorLists[index];
                },
              },
            },
            data: [], //['论坛', '微博', '微信', '新闻']
          },
          {
            type: "category",
            axisLine: {
              show: false, //坐标线
            },
            axisTick: {
              show: false, //小横线
            },
            axisLabel: {
              show: true,
              textStyle: {
                //坐标轴字颜色
                color: function (params, index) {
                  let colorLists = [
                    "#3054EC",
                    "#1A8FFF",
                    "#13C2C2",
                    "#52C41B",
                    "#A0D912",
                    "#FAD60F",
                    "#F9AD13",
                    "#FA8C15",
                    "#F95B1C",
                    "#FE4D4F",
                  ];
                  return colorLists[index];
                },
              },
            },
            data: [], //['论坛', '微博', '微信', '新闻']
          },
        ],
        xAxis: {
          show: false,
        },
        grid: {
          //图表尺寸大小
          left: "10px",
          right: "20px",
          bottom: "0%",
          top: "0%",
          containLabel: true,
        },
        animationDuration: 9000,
        series: [
          {
            type: "bar",
            barWidth: "10px",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(220, 220, 220, 0.4)",
              barBorderRadius: [30, 30, 30, 30], //圆角大小
            },
            label: {
              show: false,
              position: "right", //每一条的数据位置
            },
            itemStyle: {
              normal: {
                color: (params) => {
                  let colors = [
                    "#3054EC",
                    "#1A8FFF",
                    "#13C2C2",
                    "#52C41B",
                    "#A0D912",
                    "#FAD60F",
                    "#F9AD13",
                    "#FA8C15",
                    "#F95B1C",
                    "#FE4D4F",
                  ]; //[,]//['#9254DE','#F4222E','#5CDBD3','#1B8EFF' ]
                  return colors[params.dataIndex];
                }, //每个数据的颜色
                barBorderRadius: [30, 30, 30, 30], //圆角大小
                shadowBlur: 10,
                shadowColor: "rgba(0, 103, 255, 0.2)",
                shadowOffsetX: -5,
                shadowOffsetY: 5,
              },
            },
            data: [],
          },
        ],
      }
    }
  },
  methods:{
    getoptions() {
      var chartDom = document.getElementById("weixin");
      var myChart = echarts.init(chartDom);
      this.option2 && myChart.setOption(this.option2);
    },
  },
  watch:{
    weixinList(newval){
      if (newval) {
        
        if (newval.length > 0) {
          console.log(newval);
          let medialist = [];
          let sourceNames = [];
          newval.forEach((item, index) => {
            medialist.push(item.reprintNumb);
            sourceNames.push(item.author);
          });
          
          this.option2.yAxis[0].data = sourceNames.reverse();
          this.option2.yAxis[1].data = medialist.reverse();
          this.option2.series[0].data = medialist;

          setTimeout(() => {
            this.getoptions();
          }, 1000);
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#weixin{
  width: 100%;
  height: 100%;
}
</style>